import { action } from 'typesafe-actions';
import type { IBlockState } from './reducers/blocks';
import type { IGroupState } from './reducers/groups';
import type { IModalState } from './reducers/modal';
import type { IEnvelope, IBlock, ISignatureSettings, ISigner } from './types';

export enum ActionTypes {
  ERROR = 'ERROR',
  FETCH_ENVELOPE = 'FETCH_ENVELOPE',
  FETCH_ENVELOPE_DONE = 'FETCH_ENVELOPE_DONE',
  ZOOM_IN = 'ZOOM_IN',
  ZOOM_OUT = 'ZOOM_OUT',
  SIGN_FIELD = 'SIGN_FIELD',
  SHOW_SIGNATURE_MODAL = 'SHOW_SIGNATURE_MODAL',
  CLOSE_SIGNATURE_MODAL = 'CLOSE_SIGNATURE_MODAL',
  CANCEL_SIGNATURE_MODAL = 'CANCEL_SIGNATURE_MODAL',
  CONFIRM_SIGNATURE_MODAL = 'CONFIRM_SIGNATURE_MODAL',
  CONFIRM_SIGNATURE_MODAL_DONE = 'CONFIRM_SIGNATURE_MODAL_DONE',
  CHANGE_SIGNATURE_TEXT = 'CHANGE_SIGNATURE_TEXT',
  SUBMIT_ENVELOPE = 'SUBMIT_ENVELOPE',
  SUBMIT_ENVELOPE_DONE = 'SUBMIT_ENVELOPE_DONE',
  TERMS_ACCEPTED = 'TERMS_ACCEPTED',
  SUBMIT_ESIGN_DISCLOSURE = 'SUBMIT_ESIGN_DISCLOSURE',
  SUBMIT_ESIGN_DISCLOSURE_DONE = 'SUBMIT_ESIGN_DISCLOSURE_DONE',
  START_REQUEST = 'START_REQUEST',
  END_REQUEST = 'END_REQUEST',
  DOWNLOAD_DOCUMENTS = 'DOWNLOAD_DOCUMENTS',
  FETCH_PRESIGNED_URLS = 'FETCH_PRESIGNED_URLS',
  FETCH_PRESIGNED_URLS_DONE = 'FETCH_PRESIGNED_URLS_DONE',
  UPDATE_BLOCK = 'UPDATE_BLOCK',
  FETCH_THUMBNAILS_BY_ENVELOPE = 'FETCH_THUMBNAILS_BY_ENVELOPE',
  FETCH_THUMBNAILS_BY_ENVELOPE_DONE = 'FETCH_THUMBNAILS_BY_ENVELOPE_DONE',
  ADD_BLOCKS_TO_SIGNING_EXPERIENCE = 'ADD_BLOCKS_TO_SIGNING_EXPERIENCE',
  SIGNING_EXPERIENCE_COMPLETE = 'SIGNING_EXPERIENCE_COMPLETE',
  TAB_NEXT_BLOCK = 'TAB_NEXT_BLOCK',
  TAB_TO_BLOCK = 'TAB_TO_BLOCK',
  UPDATE_SIGNING_EXPERIENCE_BLOCK = 'UPDATE_SIGNING_EXPERIENCE_BLOCK',
  DOWNLOAD_ENVELOPE = 'DOWNLOAD_ENVELOPE',
  DOWNLOAD_ENVELOPE_DONE = 'DOWNLOADED_ENVELOPE_DONE',
  SHOW_EXIT_SIGNING_MODAL = 'SHOW_EXIT_SIGNING_MODAL',
  CLOSE_EXIT_SIGNING_MODAL = 'CLOSE_EXIT_SIGNING_MODAL',
  SET_PAGE_DIMENSIONS = 'SET_PAGE_DIMENSIONS',
  SET_PAGE_SCALE = 'SET_PAGE_SCALE',
  CLEAR_ALL_PAGE_SCALES = 'CLEAR_ALL_PAGE_SCALES',
  COMPLETE_BLOCKS_IN_GROUP = 'COMPLETE_BLOCKS_IN_GROUP',
  SET_CURRENT_DOCUMENT = 'SET_CURRENT_DOCUMENT',
  SET_PENDING_BLOCK_INFO = 'SET_PENDING_BLOCK_INFO',
  UPDATE_SIGNER_SIGNING_SETTINGS = 'UPDATE_SIGNER_SIGNING_SETTINGS',
  SIGNER_PHONE_NUMBER_COLLECTED = 'SIGNER_PHONE_NUMBER_COLLECTED',
}
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const showExitSigningModal = () => action(ActionTypes.SHOW_EXIT_SIGNING_MODAL);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const closeExitSigningModal = () => action(ActionTypes.CLOSE_EXIT_SIGNING_MODAL);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const error = (error: string) => action(ActionTypes.ERROR, error);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchEnvelope = (envelopeId: string, signerId: string) =>
  action(ActionTypes.FETCH_ENVELOPE, { envelopeId, signerId });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchEnvelopeDone = (envelope: IEnvelope) => action(ActionTypes.FETCH_ENVELOPE_DONE, envelope);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const zoomIn = () => action(ActionTypes.ZOOM_IN);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const zoomOut = () => action(ActionTypes.ZOOM_OUT);

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const signField = (documentId: string, pageNumber: number, blockId: string) =>
  action(ActionTypes.SIGN_FIELD, { documentId, pageNumber, blockId });

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const showSignatureModal = (documentId?: string, pageNumber?: number, blockId?: string) =>
  action(ActionTypes.SHOW_SIGNATURE_MODAL, { documentId, pageNumber, blockId });

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const closeSignatureModal = () => action(ActionTypes.CLOSE_SIGNATURE_MODAL);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const cancelSignatureModal = () => action(ActionTypes.CANCEL_SIGNATURE_MODAL);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const updateBlock = (documentId: string, pageNumber: number, blockId: string, blockUpdate: any) =>
  action(ActionTypes.UPDATE_BLOCK, { documentId, pageNumber, blockId, blockUpdate });

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const submitEnvelope = (
  envelopeId: string,
  signerId: string,
  data: object,
  signatureFont: string | undefined,
  signer: ISigner
) => action(ActionTypes.SUBMIT_ENVELOPE, { envelopeId, signerId, data, signatureFont, signer });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const submitEnvelopeDone = () => action(ActionTypes.SUBMIT_ENVELOPE_DONE);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const termsAccepted = () => action(ActionTypes.TERMS_ACCEPTED);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const submitEsignDisclosure = (envelopeId: string, signerId: string) =>
  action(ActionTypes.SUBMIT_ESIGN_DISCLOSURE, { envelopeId, signerId });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const submitEsignDisclosureDone = () => action(ActionTypes.SUBMIT_ESIGN_DISCLOSURE_DONE);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const confirmSignatureModal = (
  envelopeId: string,
  documentId: string,
  pageNumber: number,
  blockId: string,
  signerId: string,
  signatureSettings: ISignatureSettings,
  useExistingSettings?: boolean
) =>
  action(ActionTypes.CONFIRM_SIGNATURE_MODAL, {
    pageNumber,
    documentId,
    envelopeId,
    signerId,
    blockId,
    signatureSettings,
    useExistingSettings,
  });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const confirmSignatureModalDone = () => action(ActionTypes.CONFIRM_SIGNATURE_MODAL_DONE);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const signerPhoneNumberCollected = (contactInfo: IModalState['signerPhoneNumber']) =>
  action(ActionTypes.SIGNER_PHONE_NUMBER_COLLECTED, contactInfo);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const startRequest = () => action(ActionTypes.START_REQUEST);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const endRequest = () => action(ActionTypes.END_REQUEST);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const downloadDocuments = () => action(ActionTypes.DOWNLOAD_DOCUMENTS);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchThumbnailsByEnvelope = (envelopeId: string, numberOfPages: number) =>
  action(ActionTypes.FETCH_THUMBNAILS_BY_ENVELOPE, { envelopeId, numberOfPages });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchThumbnailsByEnvelopeDone = (pageThumbnails: any) =>
  action(ActionTypes.FETCH_THUMBNAILS_BY_ENVELOPE_DONE, { pageThumbnails });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const addBlocksToSigningExperience = (blockIds: number[]) =>
  action(ActionTypes.ADD_BLOCKS_TO_SIGNING_EXPERIENCE, { blockIds });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const signingExperienceComplete = () => action(ActionTypes.SIGNING_EXPERIENCE_COMPLETE);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const tabNextBlock = (
  currentIndex: number | null,
  blocks: IBlockState,
  groups?: IGroupState,
  completedIndex?: number
) => action(ActionTypes.TAB_NEXT_BLOCK, { currentIndex, blocks, groups, completedIndex });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const tabToBlock = (nextIndex: number) => action(ActionTypes.TAB_TO_BLOCK, { nextIndex });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const updateSigningExperienceBlock = (currentIndex: number, block?: IBlock) =>
  action(ActionTypes.UPDATE_SIGNING_EXPERIENCE_BLOCK, { currentIndex, block });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const updateSigningExperienceblock = (currentIndex: number) =>
  action(ActionTypes.UPDATE_SIGNING_EXPERIENCE_BLOCK, { currentIndex });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const downloadEnvelope = (
  envelopeId: string,
  signerId: string,
  fileName: string,
  alreadySigned: boolean,
  fileType: string
) => action(ActionTypes.DOWNLOAD_ENVELOPE, { envelopeId, signerId, fileName, alreadySigned, fileType });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const downloadedEnvelope = (blobUrl: any, fileName: string, alreadySigned: boolean, fileType: string) =>
  action(ActionTypes.DOWNLOAD_ENVELOPE_DONE, { blobUrl, fileName, alreadySigned, fileType });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const setPageDimensions = (height: number, width: number, fullPage: number) =>
  action(ActionTypes.SET_PAGE_DIMENSIONS, { height, width, fullPage });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const setPageScale = (fullPage: number, pageScale: number) =>
  action(ActionTypes.SET_PAGE_SCALE, { fullPage, pageScale });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const clearAllPageScales = () => action(ActionTypes.CLEAR_ALL_PAGE_SCALES);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const completeBlocksInGroup = (blocks: IBlock[]) => action(ActionTypes.COMPLETE_BLOCKS_IN_GROUP, { blocks });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const setCurrentDocument = (documentId: string, documentName: string) =>
  action(ActionTypes.SET_CURRENT_DOCUMENT, { documentId, documentName });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const setPendingBlockInfo = (documentId: string, pageNumber: number, blockId: string) =>
  action(ActionTypes.SET_PENDING_BLOCK_INFO, { documentId, pageNumber, blockId });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const updateSignerSigningSettings = (signingSettings: ISignatureSettings) =>
  action(ActionTypes.UPDATE_SIGNER_SIGNING_SETTINGS, signingSettings);
